import {Component, OnInit, Input} from '@angular/core';
// import {Cartypes} from '../workflow-metadata/workflow-metadata.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {LangChangeEvent} from '@ngx-translate/core';
import {AcceptDeclineDialogComponent} from "../../dialog/accept-decline-dialog/accept-decline-dialog.component";
import {MatDialog} from "@angular/material";
import {Router, ActivatedRoute, NavigationStart} from '@angular/router';
import {MessageDialogComponent} from "../../dialog/message-dialog/message-dialog.component";

export interface WorkflowLinks {
  label: string;
  path: string;
}

@Component({
  selector: 'app-workflow-navi-bar',
  templateUrl: './workflow-navi-bar.component.html',
  styleUrls: ['./workflow-navi-bar.component.css']
})
export class WorkflowNaviBarComponent implements OnInit {

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  workflowLinks: WorkflowLinks[] = [
    {label: 'Drivers Manual', path: '/upload/drivers-manual'},
    {label: 'App Assets', path: '/upload/app-assets'},
    {label: 'Disclaimer', path: '/upload/disclaimer'},
    {label: 'Hotspot Creator', path: '/upload/hotspot-creator'},
    {label: 'Validation & Upload', path: '/upload/validation-upload'}
  ];


  activeLink = null;

  constructor(private _formBuilder: FormBuilder,
              private translate: TranslateService,
              public dialog: MatDialog,
              private routerRef: Router,
              private _router: ActivatedRoute) {

    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {

      this.translate.get('NAVI_BAR.PACKAGE_UPLOAD.WORKFLOW')
        .subscribe(metadataTranslation => {

          let index = 0;
          for (let key in metadataTranslation) {
            this.workflowLinks[index].label = metadataTranslation[key].TITLE;
            index++;
          }
        });
    });
  }

  ngOnInit() {
    this.activeLink = this.workflowLinks[0];
    let urlStart=this.routerRef.url;
    this.currentActiveLink(urlStart);

    this.routerRef.events.forEach((event) => {
      if(event instanceof NavigationStart) {
        let url=event.url;
        this.currentActiveLink(url);
      }
    });


  }

  currentActiveLink(url:string){
    for(let i=0;i<this.workflowLinks.length;i++){
      let pos=this.workflowLinks[i].path.indexOf(url);
      if(pos>=0){
        this.activeLink = this.workflowLinks[i];
      }
    }
  }

  tabNavClick(tab: WorkflowLinks) {
    // console.log("tabLink onClick");
    let currentPackageId = sessionStorage.getItem('currentPackageId');

    if(currentPackageId !== null) {
      this.routerRef.navigate([tab.path], {relativeTo: this._router});
      this.activeLink = tab;
    }else{
      const messageDialog= this.dialog.open(MessageDialogComponent,{
        width: '250px',
        data: {
          title: 'Info',
          message: 'Not possible!',
          secondMsg:'Before you can change you have to fill the metadata'
        }
      })
    }

  }

  createNewPkgDialog() {

    const dialogRef = this.dialog.open(AcceptDeclineDialogComponent, {
      width: '250px',
      data: {
        title: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.TITLE'),
        message: 'Do you want to abort? Unsaved data will be lost.',
        icon: {
          add: false,
          name: ''
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        sessionStorage.removeItem('currentPackageId');
        window.location.reload();
      }
    });
  }
}
